import JassEnum from './enum';

/**
 * type playergameresult
 */
export default class JassPlayerGameResult extends JassEnum {}
